import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesOrderAddUpdateComponent } from './sales-order-add-update/sales-order-add-update.component';
import { SalesOrderListComponent } from './sales-order-list/sales-order-list.component';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from '../../core/core.module';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SalesOrderDetailAddUpdateComponent } from './sales-order-detail-add-update/sales-order-detail-add-update.component';
import { NgxPrintModule } from 'ngx-print';
import { SharedCrmModule } from '../../shared/shared-crm/shared-crm.module';
import { AddRefreshModule } from '../../shared/add-refresh/add-refresh.module';
import { SharedCustomParamDetailModule } from '../../shared/custom-param-detail/shared-custom-param-detail.module';
import { AppDirectivesModule } from '../../app-derectives/app-derectives.module';
import { JwBootstrapSwitchNg2Module } from 'jw-bootstrap-switch-ng2';
import { CompanyBranchLocationModule } from '../../shared/company-branch-location/company-branch-location.module';
import { NeoTableLibModule } from 'neo-table-lib';
import { SalesOrderPrintComponent } from './sales-order-print/sales-order-print.component';
import { SOEmailSenderComponent } from './so-email-sender/so-email-sender.component';
import { SalesOrderPrintHistoryComponent } from './sales-order-print-history/sales-order-print-history.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SoInvoicePrintComponent } from './so-invoice-print/so-invoice-print.component';

const salesOrderRoutes: Routes = [
  {
    path: 'salesOrderList',
    component: SalesOrderListComponent,
  },
  {
    path: 'addUpdateSalesOrder',
    component: SalesOrderAddUpdateComponent,
  },
  {
    path: 'addUpdateSalesOrder/:id',
    component: SalesOrderAddUpdateComponent,
  },
];

@NgModule({
  declarations: [
    SalesOrderAddUpdateComponent,
    SalesOrderListComponent,
    SalesOrderDetailAddUpdateComponent,
    SalesOrderPrintComponent,
    SOEmailSenderComponent,
    SalesOrderPrintHistoryComponent,
    SoInvoicePrintComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(salesOrderRoutes),
    CoreModule,
    Ng2SmartTableModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxPrintModule,
    FormsModule,
    SharedCrmModule,
    AddRefreshModule,
    SharedCustomParamDetailModule,
    AppDirectivesModule,
    JwBootstrapSwitchNg2Module,
    CompanyBranchLocationModule,
    NeoTableLibModule,
    NgbModule
  ],
  exports: [SalesOrderListComponent, SalesOrderAddUpdateComponent,SalesOrderPrintComponent],
  entryComponents: [SalesOrderListComponent, SalesOrderAddUpdateComponent],
})
export class SalesOrderModule {}
